<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Visualizar Área</h1>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Título:">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Título"
                                autocomplete="titulo"
                                v-model="form.titulo"                                
                                disabled
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Situação:">
                <b-form-radio-group disabled v-model="form.status" :options="status"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
            <b-form-group label="Descrição: ">
              <b-form-textarea   
                v-model="form.descricao"             
                rows="5"
                max-rows="6"
                disabled
              ></b-form-textarea>
            </b-form-group> 
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/areas')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  created () {
    this.loadArea(this.$route.params.id)
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        descricao: null,
        status: true
      },
      disable_buttons: false,
      status: [
        {value: true, text: 'Ativo'},
        {value: false, text: 'Inativo'}
      ],
    }
  },

  methods: {
    loadArea (id) {
      Vue.http.get('api/areas/' + id).then(response => {
     
        let data = response.body.data[0]       
       
        this.form.titulo = data.titulo  
        this.form.descricao = data.descricao
        this.form.status = false

        if(data.status > 0){
          this.form.status = true
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/area/AreaVisualizar.vue